import { Component, Input, OnInit } from '@angular/core';
import {
  DocTypes,
  FileNode,
  FileService
} from '../../../services/file.service';
import { Capacitor } from '@capacitor/core';
import * as Sentry from '@sentry/angular';
import { FilesHelperService } from '../../../services/files-helper.service';

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss']
})
export class FileComponent implements OnInit {
  @Input() file: FileNode;
  @Input() fileIndex: number;
  @Input() parentDateName?: string;

  public orderId: number;
  public extension: string;

  constructor(
    private fileService: FileService,
    private filesHelper: FilesHelperService
  ) {}

  ngOnInit(): void {
    this.orderId =
      +window.location.pathname.split('/')[
        window.location.pathname.split('/').findIndex(el => el === 'days') + 1
      ];

    const splitted: string[] = this.file.name.split('.');
    const extension =
      splitted.length > 1 ? splitted[splitted.length - 1].toLowerCase() : '';

    if (['jpeg', 'jpg', 'png', 'gif'].includes(extension)) {
      this.extension = 'image';
    } else if (['xls', 'xlsx'].includes(extension)) {
      this.extension = 'excel';
    } else if (extension) {
      this.extension = extension;
    } else {
      this.extension = 'empty';
    }
  }

  async downloadFile() {
    if (this.file.documentId) {
      try {
        switch (this.file.documentType) {
          case DocTypes.TRUNCATED_RTS: {
            const shipmentDate = this.extractShipmentDate();

            if (!shipmentDate) {
              const errorMessage = 'Не удалось определить дату отгрузки для РТС документа';
              Sentry.captureMessage(errorMessage);
              throw new Error(errorMessage);
            }

            await this.fileService.downloadFileForDeal(
              Number(this.file.documentId),
              this.file.name,
              this.file.documentType,
              this.orderId,
              shipmentDate
            );
            break;
          }
          default: {
            const filePath = await this.fileService.downloadFileForDeal(
              Number(this.file.documentId),
              this.file.name,
              this.file.documentType
            );

            // Only try to open it if we're on a native platform
            if (filePath && Capacitor.isNativePlatform()) {
              const extension =
                this.file.name.toLowerCase().split('.').pop() || '';
              const mimeType =
                this.filesHelper.getMimeTypeFromExtension(extension);
              await this.filesHelper.openFile(filePath, mimeType);
            }
            // For web platform, the file is already downloaded by downloadFileForDeal
            break;
          }
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    }
  }

  getIconForExtension(extension: string): string {
    switch (this.file.documentType) {
      case DocTypes.TRUNCATED_RTS:
        return 'excel-file-icon';
      case DocTypes.FORWARDER_FINAL_DOCS:
        return 'archive-file-icon';
      default:
        return `${extension}-file-icon`;
    }
  }

  /**
   * Извлекает дату отгрузки из контекста
   */
  private extractShipmentDate(): string | undefined {
    if (this.parentDateName) {
      // Если дата передана напрямую из родительского компонента
      return this.parentDateName;
    }

    // Можно добавить дополнительную логику для извлечения даты
    // из других источников, если необходимо
    return undefined;
  }
}
